import { c as _c } from "react/compiler-runtime";
import { Facebook } from "@repo/design-system/components/icons/social";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@repo/design-system/components/ui/drop-down-menu";
import { cn } from "@repo/design-system/utils/cn";
import { getCanonicalUrl } from "@repo/design-system/utils/helpers";
import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";
import { useLanguage } from "~/translations/loader/use-language";
import type { Job } from "~/types/job";
import { LinkedInIcon } from "../icons/linkedin-eon";
import { MailIcon } from "../icons/mail-eon";
import { ShareIcon } from "../icons/share-eon";
import { XingIcon } from "../icons/xing-eon";
import { Button, type ButtonProps } from "./button-eon";
export default function ShareDropdown(t0) {
  const $ = _c(33);
  const {
    job,
    children,
    className,
    variant
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job) {
    const canonicalUrl = getCanonicalUrl(job);
    t1 = canonicalUrl.replace("=", "%3D");
    $[0] = job;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cleanHref = t1;
  let t2;
  if ($[2] !== job.data.title) {
    t2 = job.data.title.replace("&", "and");
    $[2] = job.data.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const cleanTitle = t2;
  let t3;
  if ($[4] !== job.data.locations) {
    t3 = job.data.locations.every(_temp);
    $[4] = job.data.locations;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const isRomanianCompany = t3;
  const t4 = `mailto:?subject=Job "${cleanTitle}" (Job-ID: ${job.data.jobNumber})&body=${cleanHref}`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MailIcon className="size-5 text-black group-hover:text-white" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t.jobad_share_mail || $[8] !== t4) {
    t6 = {
      platform: "mail",
      href: t4,
      icon: t5,
      text: t.jobad_share_mail
    };
    $[7] = t.jobad_share_mail;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const mailShare = t6;
  let t7;
  if ($[10] !== cleanHref || $[11] !== isRomanianCompany || $[12] !== mailShare || $[13] !== t.jobad_share_facebook || $[14] !== t.jobad_share_linkedin || $[15] !== t.jobad_share_xing) {
    t7 = isRomanianCompany ? [mailShare, {
      platform: "facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${cleanHref}`,
      icon: <Facebook className="size-5 text-black group-hover:text-white" />,
      text: t.jobad_share_facebook
    }] : [mailShare, {
      platform: "linkedin",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${cleanHref}`,
      icon: <LinkedInIcon className="size-5 text-black group-hover:text-white" />,
      text: t.jobad_share_linkedin
    }, {
      platform: "xing",
      href: `https://www.xing.com/spi/shares/new?url=${cleanHref}`,
      icon: <XingIcon className="size-5 text-black group-hover:text-white" />,
      text: t.jobad_share_xing
    }];
    $[10] = cleanHref;
    $[11] = isRomanianCompany;
    $[12] = mailShare;
    $[13] = t.jobad_share_facebook;
    $[14] = t.jobad_share_linkedin;
    $[15] = t.jobad_share_xing;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const socialShare = t7;
  let t8;
  if ($[17] !== className) {
    t8 = cn("group w-full gap-2", className);
    $[17] = className;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== children) {
    t9 = children ? children : <><ShareIcon className="size-6 stroke-2" /><ChevronDown className="size-6 stroke-2 duration-200 ease-in-out group-data-[state=open]:rotate-180" /></>;
    $[19] = children;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t.jobad_share_title) {
    t10 = <span className="sr-only">{t.jobad_share_title}</span>;
    $[21] = t.jobad_share_title;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8 || $[25] !== t9 || $[26] !== variant) {
    t11 = <DropdownMenuTrigger asChild={true}><Button className={t8} variant={variant}>{t9}{t10}</Button></DropdownMenuTrigger>;
    $[23] = t10;
    $[24] = t8;
    $[25] = t9;
    $[26] = variant;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== socialShare) {
    t12 = <DropdownMenuContent align="end" className="w-full">{socialShare.map(_temp2)}</DropdownMenuContent>;
    $[28] = socialShare;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== t12) {
    t13 = <DropdownMenu>{t11}{t12}</DropdownMenu>;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
}
function _temp2(social) {
  return <DropdownMenuItem asChild={true} key={social.href}><CustomLink blank={true} className="group flex items-center gap-3 hover:bg-secondary!" href={social.href}>{social.icon}<span>{social.text}</span></CustomLink></DropdownMenuItem>;
}
function _temp(location) {
  return location.countryCode === "RO";
}